import { render } from "./circleOfFriends.vue?vue&type=template&id=49f683aa&scoped=true"
import script from "./circleOfFriends.vue?vue&type=script&lang=js"
export * from "./circleOfFriends.vue?vue&type=script&lang=js"

import "./circleOfFriends.vue?vue&type=style&index=0&id=49f683aa&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f683aa"]])

export default __exports__